import React, { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { store } from "./store/reducer";
import Router from "./routes/route";
import OfflinePage from "./components/OfflinePage";
import "bootstrap/dist/css/bootstrap.min.css";


import "react-toastify/dist/ReactToastify.css";
import "./App.css";

const queryClient = new QueryClient();

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <div className="App transparant_Scrollbar">
          {isOnline ? <Router /> : <OfflinePage />}{" "}
          {/* 👈 Conditionally show */}
          <ToastContainer autoClose={3000} />
        </div>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
